import { createContext, useContext } from 'react';
export const SharedThreadCreateSpaceContext = createContext(undefined);
export function useSharedThreadCreateSpace() {
    return useContext(SharedThreadCreateSpaceContext);
}
//# sourceMappingURL=SharedThreadCreateSpaceContext.js.map